import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import OrderPayment from "../components/shopPartials/OrderPayment";
import { useCart } from "../components/contexts/CartContext";
import { useGeneral } from "../components/contexts/GeneralContext";
import CartSummary from "../components/shopPartials/CartSummary";
import {
  usePayment,
  useStep,
} from "../components/contexts/SubscriptionContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MealPayment from "../components/planPartials/MealPayment";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import { useEffect } from "react";
import PaymentUpdated from "../components/planPartials/PaymentUpdated";
import GeneralButton from "../components/common/GeneralButton";
import { TiChevronLeft, TiChevronRight } from "react-icons/ti";

const PaymentPage = () => {
  const { type } = useParams();
  const { discountCoupons } = useGeneral();
  const { cart, fetchCart } = useCart();
  const navigate = useNavigate();
  const { fetchCards, savedCards } = usePayment();
  const { goToStep } = useStep();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const renew = params.get("renew");

  useEffect(() => {
    goToStep("5");
    fetchCart();
  }, []);
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="">
        <Header code={discountCoupons} />
        <BodyWrapper className="mb-4 lg:mb-0">
          {type === "meals" && renew != "true" && (
            <TopStepsStatus url={""} rightText="" />
          )}
          <p
            className={`text-34pt pb-4 md:pb-6 2.5xl:pb-9  ${
              renew != "true"
                ? "mt-4 md:mt-6 2.5xl:mt-9"
                : "pb-4 md:pb-6 2.5xl:pb-8"
            }`}
          >
            Payment Summary
          </p>

          <div
            className={`grid grid-cols-1 2xl:grid-cols-[2fr_0.9fr] 
             `}
          >
            {/* ${
              savedCards.length > 0
                ? "2xl:grid-cols-[4fr_0.9fr] 2.5xl:grid-cols-[3fr_0.9fr]"
                : "2xl:grid-cols-[1fr_0.9fr]"
            }  */}
            {type === "order" ? (
              <div className="w-full xl:w-[90%] ">
                <div
                  className={`bg-[#DEE2DD]/40 rounded-[15px] w-full   p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[70px]`}
                >
                  <CartSummary cart={cart?.orderCart} hidePromo={true} />
                  {/* <OrderPayment /> */}
                </div>
                <div className="flex items-end justify-between mt-9">
                  <GeneralButton
                    onClick={() => navigate(-1)}
                    text="Prev step"
                    title=""
                    iconPosition="Left"
                    bgColor="#ccc"
                    textColor="#000"
                    icon={<TiChevronLeft size={24} className="me-4" />}
                    className="text-24pt"
                  />
                  <GeneralButton
                    onClick={() => navigate("/order-payment-processor")}
                    text="Pay Now"
                    title=""
                    type="button"
                    bgColor="#30160E"
                    textColor="#ccc"
                    icon={<TiChevronRight size={24} className="ms-4" />}
                    className="text-24pt"
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="w-full xl:w-[90%] ">
                  <div
                    className={`bg-[#DEE2DD]/40 rounded-[15px] w-full   p-5 md:px-10 md:py-10 2.5xl:px-24 2.5xl:py-[70px]`}
                  >
                    <CartSummary cart={cart?.mealCart} hidePromo={true} />
                    {/* <OrderPayment /> */}
                  </div>
                  <div className="flex items-end justify-between mt-9">
                    <GeneralButton
                      onClick={() => navigate(-1)}
                      text="Prev step"
                      title=""
                      iconPosition="Left"
                      bgColor="#ccc"
                      textColor="#000"
                      icon={<TiChevronLeft size={24} className="me-4" />}
                      className="text-24pt"
                    />
                    <GeneralButton
                      onClick={
                        renew === "true"
                          ? () =>
                              navigate("/meals-payment-processor?renew=true")
                          : () => navigate("/meals-payment-processor")
                      }
                      text="Pay Now"
                      title=""
                      type="button"
                      bgColor="#30160E"
                      textColor="#ccc"
                      icon={<TiChevronRight size={24} className="ms-4" />}
                      className="text-24pt"
                    />
                  </div>
                </div>
                {/* <div className="">
                <PaymentUpdated />
              </div> */}
              </>
            )}
          </div>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default PaymentPage;
